import React, { useState, useEffect } from 'react';
import { useData, useStore, useSettings } from '../context/store';
import useUpdateTerm from '../methods/useUpdateTerm';

const toggleSubList = function (target) {
	target.parentNode.parentNode.classList.toggle('active');
};

const ChildTermsToggle = function (props) {
	if (props.termCount) {
		return (
			<button
				className="tf-taxonomy__sub-list-toggle"
				onClick={(e) => toggleSubList(e.target)}
			>
				<div className="sr-only">Toggle sub-list</div>
			</button>
		);
	}
	return '';
};

const ChildTerms = function (props) {
	const state = useData();

	const { updateTerm } = useUpdateTerm();

	if (props.terms.length) {
		const sortedTerms = [...props.terms].sort((a, b) => {
			// console.log('aa -- ', a);
			const termA = isNaN(a.name) ? a.name.toLowerCase() : a;
			const termB = isNaN(b.name) ? b.name.toLowerCase() : b;

			if (termA < termB) {
				return -1;
			}

			if (termA > termB) {
				return 1;
			}

			return 0;
		});

		return (
			<ul className="tf-taxonomy__sub-list">
				{sortedTerms.map((term) => {
					// See if term is checked
					if (
						'undefined' !==
						typeof state.selectedTaxonomies[props.taxonomy.name]
					) {
						term.checked = state.selectedTaxonomies[
							props.taxonomy.name
						].includes(term.term_id);
					} else {
						term.checked = false;
					}

					return (
						<li
							className="tf-taxonomy__list-item"
							key={term.term_id}
						>
							<label
								className="tf-taxonomy__list-item-label"
								htmlFor={`taxonomy-term-${term.term_id}`}
							>
								<input
									className="sr-only tf-taxonomy__input"
									type="checkbox"
									id={`taxonomy-term-${term.term_id}`}
									data-value={term.term_id}
									onChange={(e) =>
										updateTerm(
											props.taxonomy.name,
											term.term_id,
											e.target.checked
										)
									}
									checked={term.checked}
								/>
								<div className="tf-taxonomy__checkbox"></div>
								<span
									dangerouslySetInnerHTML={{
										__html: term.name,
									}}
								/>
							</label>
						</li>
					);
				})}
			</ul>
		);
	}
	return '';
};

export default function TaxonomyList(props) {
	const { state, dispatch } = useStore();

	const { updateTerm } = useUpdateTerm();

	const getTermByID = function (term_id, terms) {
		let matchingTerm = null;
		terms.forEach((term) => {
			if (term.term_id == term_id) {
				matchingTerm = term;
			}
		});

		return matchingTerm;
	};

	// We only do 1 parent deep currently.
	const getNestedTerms = function (terms, taxonomy) {
		const parents = new Map();
		const children = new Map();

		for (const key in terms) {
			const term = terms[key];

			if ('undefined' !== typeof state.selectedTaxonomies[taxonomy]) {
				term.checked = state.selectedTaxonomies[taxonomy].includes(term.term_id);
			} else {
				term.checked = false;
			}

			if (0 === term.parent) {
				parents.set(term.term_id, term);
			} else {
				if (!children.has(term.parent)) {
					children.set(term.parent, []);
				}

				children.get(term.parent).push(term);
			}
		}

		for (const [key, parent] of parents) {
			if (children.has(key)) {
				parent.children = children.get(key);
			} else {
				parent.children = [];
			}
		}

		for (const [parentKey, childrenArr] of children) {
			for (const child of childrenArr) {
				if (child.checked) {
					parents.get(parentKey).isOpen = true;
				}
			}
		}

		// Convert Map to Array for sorting
		let parentsArray = Array.from(parents.values());

		return parentsArray.sort((a, b) => {
			if (a.taxonomy !== "tc_type" && b.taxonomy !== "tc_type" && a.taxonomy !== 'tc_level' && b.taxonomy !== 'tc_level') {
				if (a.name && b.name) {
					const termA = isNaN(a.name) ? a.name.toLowerCase() : a.name;
					const termB = isNaN(b.name) ? b.name.toLowerCase() : b.name;

					if (termA < termB) {
						return -1;
					}

					if (termA > termB) {
						return 1;
					}
				}
			}

			return 0;
		});
	};

	const taxonomy = props.taxonomy;

	if ('undefined' !== typeof taxonomy.custom_menu) {
		// console.log('taxon ', taxonomy);
		return taxonomy.custom_menu.map((menuItem, index) => {
			const term = getTermByID(menuItem.term, taxonomy.terms);

			// See if term is checked
			if (
				'undefined' !== typeof state.selectedTaxonomies[taxonomy.name]
			) {
				term.checked = state.selectedTaxonomies[taxonomy.name].includes(
					`${term.term_id}-${index}`
				);
			} else {
				term.checked = false;
			}

			if (null !== term) {
				return (
					<li className="tf-taxonomy__list-item" key={index}>
						<div className="tf-taxonomy__list-item-top">
							<label
								className="tf-taxonomy__list-item-label"
								htmlFor={`taxonomy-term-${term.term_id}-${index}`}
							>
								<input
									className="sr-only tf-taxonomy__input"
									type="checkbox"
									id={`taxonomy-term-${term.term_id}-${index}`}
									data-value={`${term.term_id}-${index}`}
									onChange={(e) =>
										updateTerm(
											taxonomy.name,
											`${term.term_id}-${index}`,
											e.target.checked
										)
									}
									checked={term.checked}
								/>
								<div className="tf-taxonomy__checkbox"></div>
								<span
									dangerouslySetInnerHTML={{
										__html: menuItem.title,
									}}
								/>
							</label>
						</div>
					</li>
				);
			}
			return '';
		});
	}
	const nestedTerms = getNestedTerms(taxonomy.terms, taxonomy.name);

	return nestedTerms.map((term) => {
		const liClass = term.isOpen
			? 'tf-taxonomy__list-item active'
			: 'tf-taxonomy__list-item';

		return (
			<li className={liClass} key={term.term_id}>
				<div className="tf-taxonomy__list-item-top">
					<label
						className="tf-taxonomy__list-item-label"
						htmlFor={`taxonomy-term-${term.term_id}`}
					>
						{/* scrolls to bottom when ID is present */}
						<input
							className="sr-only tf-taxonomy__input"
							type="checkbox"
							id={`taxonomy-term-${term.term_id}`}
							data-value={term.term_id}
							onChange={(e) =>
								updateTerm(
									taxonomy.name,
									term.term_id,
									e.target.checked
								)
							}
							checked={term.checked}
						/>
						<div className="tf-taxonomy__checkbox"></div>
						<span dangerouslySetInnerHTML={{ __html: term.name }} />
					</label>

					<ChildTermsToggle termCount={term.children.length} />
				</div>

				<ChildTerms terms={term.children} taxonomy={taxonomy} />
			</li>
		);
	});
}
